import { Button, Flex, Icon } from '@oplog/express';
import { resourceActions, resourceSelectors } from '@oplog/resource-redux';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ResourceType } from '../../../../models';
import { AddressTypeOutputDTO } from '../../../../services/swagger';
import { StoreState } from '../../../../store/initState';
import { ModalBox } from '../../../molecules/TouchScreen';
import { ScanPackageModals } from './ScanPackageColumn';

interface IReprintModal {
  setIsOpen: (name: ScanPackageModals, status?: boolean) => void;
  isReprint: boolean;
  station: AddressTypeOutputDTO;
  cargoPackageBarcode: string;
}

const ReprintModal: FC<IReprintModal> = ({ setIsOpen, isReprint, station, cargoPackageBarcode }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isBusy: boolean = useSelector((state: StoreState) =>
    resourceSelectors.isBusy(state.resources, ResourceType.PrintApprovedCargoPackageCarrierLabel)
  );

  return (
    <ModalBox
      onClose={() => null}
      isOpen={true}
      width={640}
      headerText={t(`TouchScreen.SlamStation.Modals.${isReprint ? 'ReprintModal' : 'PrintModal'}`)}
      contentBoxProps={{
        py: '60',
        px: '30',
        color: 'palette.purple_darker',
        border: 'sm',
        borderColor: 'transparent',
        borderRadius: 'md',
      }}
      overlayProps={{
        backgroundColor: 'palette.black',
        opacity: 0.6,
      }}
      icon={
        <Flex
          width={120}
          height={120}
          borderRadius="full"
          bg="palette.softBlue"
          alignItems="center"
          justifyContent="center"
        >
          <Icon name="far fa-engine-warning" fontSize={52} color="palette.white" />
        </Flex>
      }
    >
      {isReprint && (
        <Button
          onClick={() => setIsOpen(isReprint ? ScanPackageModals.Reprint : ScanPackageModals.Print, false)}
          variant="alternative"
          kind="outline"
          width={1 / 4}
          fontWeight={700}
        >
          {t('Modal.Cancel')}
        </Button>
      )}
      <Button
        onClick={() => {
          dispatch(
            resourceActions.resourceRequested(ResourceType.PrintApprovedCargoPackageCarrierLabel, {
              params: {
                addressLabel: station.label,
                cargoPackageBarcode: cargoPackageBarcode,
                isForcePrint: isReprint ? true : false,
              },
            })
          );
          setIsOpen(isReprint ? ScanPackageModals.Reprint : ScanPackageModals.Print, false);
        }}
        isLoading={isBusy}
        variant="alternative"
        width={isReprint ? 1 / 4 : 1 / 2}
        fontWeight={700}
      >
        {t(`Enum.${isReprint ? 'PrintAction' : 'PrintLabel'}`)}
      </Button>
    </ModalBox>
  );
};

export default ReprintModal;
